/* eslint-disable import/no-named-as-default-member */
import React from "react";

import dealStatuses from "../../../constants/status";
import DealTable from "../../Global/TablePreferenceColumns/DealTable";
import { default as PipelineDealTableColumns } from "../../Global/TablePreferenceColumns/DealTableColumns/PipelineDealTableColumns";

export default class ActiveDeals extends React.Component {
  render() {
    return (
      <div>
        <DealTable
          screenType="pipeline_deal_table"
          TableScreenElements={PipelineDealTableColumns}
          status={[dealStatuses.PIPELINE, dealStatuses.REFINANCE, dealStatuses.ADDING_SUPPLEMENTAL, dealStatuses.MODIFYING]}
          fundId={null}
          rowsPerPage={this.props.rowsPerPage}
          tableConfigItemId={this.props.tableConfigItemId}
          page={this.props.page}
          updateRowsPerPage={this.props.updateRowsPerPage}
          updatePage={this.props.updatePage}
        />
      </div>
    );
  }
}
